import { required, optional, array } from 'AppReact/schema';

export default {
    default: required(['boolean', 'string', 'integer']),
    value: required(['boolean', 'string', 'integer', 'array']),
    description: required('string'),
    name: required('string'),
    selection: optional('string')
}